import type { MapboxMap } from "@/layers/MapboxMap";

export function expireAllTiles(map: MapboxMap, sources: string[]) {
  if (sources.length) {
    for (const sourceId of sources) {
      const sourceCaches = map.style.getSourceCaches(sourceId);
      for (const sourceCache of sourceCaches) {
        const tiles = sourceCache._tiles;
        for (const tileId in tiles) {
          delete tiles[tileId];
        }
        sourceCache.reload();
      }
    }

    map.triggerRepaint();
    map.fire("move");
  }
}
